export const FOOTER_COMMENTS_SUMMARY_FEEDBACK_ENTRYPOINT_ID =
	'775fa156-8bed-4310-af75-c6d1148b88fb';
